// import { ProGalleryOptions } from './gallery.types';
import { addPresetOptions } from 'pro-gallery-lib';
var shouldHaveAutoHeight = function (options) {
    if (options === void 0) { options = {}; }
    options = addPresetOptions(options);
    //  TODO import and use consts
    var should = options.scrollDirection === 0 && options.enableInfiniteScroll;
    return should;
};
export default shouldHaveAutoHeight;
//# sourceMappingURL=heightSourceHelper.js.map